<script setup lang="ts">
  import {
    Avatar,
    AvatarFallback,
    AvatarImage
  } from '@gat-ship/vue-components/avatar'
  import { cn } from '@gat-ship/vue-components'
  import type { HTMLAttributes } from 'vue'

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      avatarClass?: HTMLAttributes['class']
      variant?: 'avatar-only' | 'default'
      userId: string
      imageUrl?: string | null
      fullName: string
      initials?: string
      email?: string
      isActiveTenantUser: boolean
      isTenantAdmin?: boolean
    }>(),
    {
      variant: 'default'
    }
  )
</script>

<template>
  <div class="relative">
    <div
      :data-variant="variant"
      :aria-label="fullName"
      :class="
        cn(
          'flex items-center justify-start gap-2.5 overflow-hidden data-[variant=default]:px-2',
          props.class
        )
      "
    >
      <Avatar :class="cn('relative size-10 rounded-full', avatarClass)">
        <AvatarImage :src="imageUrl ?? ''" />
        <AvatarFallback>{{ initials }}</AvatarFallback>
      </Avatar>
      <div v-if="variant === 'default'" class="flex flex-col overflow-hidden">
        <div class="flex items-center justify-start gap-2 self-stretch">
          <div
            class="justify-center truncate text-sm font-medium leading-tight"
          >
            {{ fullName }}
          </div>
          <!-- <div
            class="justify-center overflow-hidden truncate text-sm font-medium uppercase leading-tight"
          >
            ({{ initials }})
          </div> -->
        </div>
        <div
          class="text-soft justify-center overflow-hidden truncate text-sm font-normal lowercase leading-tight"
        >
          {{ email }}
        </div>
      </div>
    </div>
    <gat-icon
      v-if="!isActiveTenantUser"
      :icon="$icons.tenantUser.base.inactive"
      class="text-destructive absolute left-0 top-0 size-4"
    />
    <gat-icon
      v-else-if="isTenantAdmin"
      :icon="$icons.tenantUser.base.tenantAdmin"
      class="absolute left-0 top-0 size-4 text-yellow-500"
    />
  </div>
</template>
